import { useEffectOnce } from "@be-miniapp/ui/hooks/use-effect-once"
import { useNavigate } from "@be-miniapp/ui/hooks/use-navigate"

interface NavigateProps {
  to: string
  replace?: boolean
}

const Navigate = ({ to, replace }: NavigateProps) => {
  const navigate = useNavigate()

  useEffectOnce(() => {
    navigate(to, {
      animate: false,
      replace,
    })
  })

  return null
}

export { Navigate }
